import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LoginButton from './LoginButton';

const O365Button: FC = () => {
  const { t } = useTranslation();

  const handleNavigate = useCallback(() => {
    const redirectURL = (process.env.REACT_APP_O365_AUTH_URL || '').replace(
      'api_root',
      process.env.REACT_APP_API_ROOT_V2 || ''
    );
    const absoluteURL = new URL(redirectURL, window.location.origin).href;
    setTimeout(() => {
      window.location.href = absoluteURL;
    }, 0);
  }, []);

  return (
    <LoginButton
      label={t('security.sso.o365Button.text')}
      handleClick={handleNavigate}
      icon={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175 211.7">
          <g id="g10" transform="matrix(1.25,0,0,-1.25,-44.29975,283.3775)">
            <g id="g12" transform="matrix(1.0173979,0,0,1.0267549,-12.619977,-4.9244629)">
              <path
                fill="#FFF"
                d="M136.5,84c0.2,1.5,0.3,112.5,0.1,114.9c-19-4.5-38-9-57.1-13.5
            v-78.2c-9.8-3.8-19.6-7.6-29.4-11.4c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.1c0,0.3-0.1,0.6-0.1,0.9c0,31.6,0,63.2,0,94.8
            c0.4,0.5,1,0.6,1.5,0.8c28,10.4,55.9,20.7,83.9,31.1c1,0.4,1.8,0.5,2.9,0.2c15.3-4.4,30.7-8.8,46.1-13.2c0.2-0.1,0.4-0.1,0.8-0.2
            V77.2c-4.4-1.2-8.8-2.4-13.2-3.6c-11.1-3-22.3-6.1-33.4-9.1c-1.1-0.3-2-0.3-3.1,0.1c-27.5,10.1-55,20.1-82.5,30.2
            c-0.5,0.2-1.1,0.4-1.5,0.9C79.6,91.7,108,87.9,136.5,84L136.5,84z"
              />
            </g>
          </g>
        </svg>
      }
    />
  );
};

export default O365Button;
